/**
 * Utility functions for timezone formatting
 */

/**
 * Format a date to the specified timezone
 * @param {Date|string} date - The date to format
 * @param {string} timezone - The timezone to format to (e.g., 'America/New_York')
 * @param {Object} options - Intl.DateTimeFormat options
 * @returns {string} Formatted date string
 */
export const formatDateToTimezone = (date, timezone, options = {}) => {
    const defaultOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: timezone
    };

    const formatOptions = { ...defaultOptions, ...options };

    try {
        return new Intl.DateTimeFormat('en-US', formatOptions).format(new Date(date));
    } catch (error) {
        console.error('Error formatting date to timezone:', error);
        // Fallback to local timezone if timezone is invalid
        return new Date(date).toLocaleString();
    }
};

/**
 * Format a date to the default timezone from config
 * @param {Date|string} date - The date to format
 * @param {string} defaultTimezone - The default timezone from config
 * @returns {string} Formatted date string
 */
export const formatDateWithDefaultTimezone = (date, defaultTimezone = 'UTC') => {
    return formatDateToTimezone(date, defaultTimezone);
};
